import React from "react";

import {DishDetailsItem} from "@apps/dish/interfaces";

import {NutritionChart} from "@components/dish/NutritionChart";

import AllergenNotice from "../AllergenNotice";
import AllergensSection from "./AllergensSection";
import styles from "./DishItemNutrition.scss";
import NotAvailableMessagesSection from "./NotAvailableMessagesSection";
import NutritionInfosSection from "./NutritionInfosSection";

type DishItemNutritonProps = {
  dish: DishDetailsItem;
};

export default function DishItemNutrition({
  dish,
}: DishItemNutritonProps): JSX.Element {
  const hasAllergens = (dish.allergens?.length ?? 0) > 0;
  const hasNutritionInfos = (dish.nutrition_infos?.length ?? 0) > 0;
  const hasFixedSideItem = Boolean(dish.fixed_side_item);
  const hasFixedSideItemAllergens =
    (dish.fixed_side_item?.allergens?.length ?? 0) > 0;
  const hasFixedSideItemNutritionInfos =
    (dish.fixed_side_item?.nutrition_infos?.length ?? 0) > 0;

  return (
    <div className={styles.itemNutrition}>
      <div>
        <em>
          <strong>Allergen Notice:</strong>
          <AllergenNotice tenantSlug={dish.operator_slug} />
        </em>
      </div>
      {hasAllergens && <AllergensSection allergens={dish.allergens!} />}
      <div>
        <NotAvailableMessagesSection
          hasAllergens={hasAllergens}
          hasNutritionInfos={hasNutritionInfos}
        />
      </div>
      {hasFixedSideItem && (
        <div>
          {hasFixedSideItemAllergens && (
            <AllergensSection
              allergens={dish.fixed_side_item!.allergens!}
              isFixedSideItem={true}
            />
          )}
          <NotAvailableMessagesSection
            hasAllergens={hasFixedSideItemAllergens}
            hasNutritionInfos={hasFixedSideItemNutritionInfos}
            isFixedSideItem={true}
          />
        </div>
      )}

      {dish.nutrition_estimate && (
        <div>
          <NutritionChart estimates={dish.nutrition_estimate.estimates} />
        </div>
      )}

      {dish.nutrition_tip && (
        <div className={styles.nutritionistTip}>
          <div>nutritionist tip</div>
          {dish.nutrition_tip}
        </div>
      )}

      {dish.ingredients && (
        <div>
          <strong>Ingredients</strong>
          <div
            dangerouslySetInnerHTML={{
              __html: dish.ingredients,
            }}
          ></div>
        </div>
      )}

      {hasNutritionInfos && (
        <div>
          <NutritionInfosSection nutritionInfos={dish.nutrition_infos!} />
          {hasFixedSideItemNutritionInfos && (
            <div>
              <NutritionInfosSection
                nutritionInfos={dish.fixed_side_item!.nutrition_infos!}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
